/**
 * Technology Filter Dropdown Width Constants
 *
 * Defines custom widths for filter dropdowns to accommodate long text values.
 * Extracted from config/filters.ts for better organization.
 */

/**
 * Filter dropdown width configuration for technology filters
 *
 * Defines custom widths for filters that need more space to display full text.
 * Filters not listed here will use the default width (400px).
 *
 * Common technology filters that may need wider dropdowns:
 * - vendor: Long vendor names
 * - product: Long product names
 * - version: Long version strings
 * - cpe: Very long CPE identifiers
 *
 * @example
 * ```tsx
 * const width = FILTER_DROPDOWN_WIDTHS.vendor; // 600
 * const defaultWidth = FILTER_DROPDOWN_WIDTHS.default; // 400
 * ```
 */
export const FILTER_DROPDOWN_WIDTHS = {
  /** Wide dropdown for long vendor names */
  vendor: 600,
  /** Wide dropdown for long product names */
  product: 600,
  /** Wide dropdown for version strings */
  version: 500,
  /** Extra wide dropdown for CPE identifiers */
  cpe: 1000,
  /** Default width for all other filters */
  default: 400,
} as const;
